import React from 'react';
import {Subject} from 'rxjs/Subject';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/auditTime';
import 'rxjs/add/operator/groupBy';
import 'rxjs/add/operator/do';

import Config from 'Config';

const debounceValueChanged = (Component) => {
    return class extends React.Component {
        constructor(props) {
            super(props);

            this.valueChangedSubject = new Subject()
                .groupBy((data) => data.id + data.field)
                .mergeMap(group => group
                        // .auditTime(Config.TEXT_INPUT_DEBOUNCE_TIME)
                    .debounceTime(Config.TEXT_INPUT_DEBOUNCE_TIME)
                );
            this.valueChangedSubject.subscribe({
                // Pass arguments as they would've been passed without this HOC
                next: (args) => {
                    this.props.onValueChanged(...args)
                },
                error: (err) => console.error(err)
            });

            this.validationErrorSubject = new Subject()
                .groupBy((data) => data.id + data.field)
                .mergeMap(group => group
                        .auditTime(Config.TEXT_INPUT_DEBOUNCE_TIME)
                    // .debounceTime(Config.TEXT_INPUT_DEBOUNCE_TIME)
                );
            this.validationErrorSubject.subscribe({
                // Pass arguments as they would've been passed without this HOC
                next: (args) => {
                    this.props.onValidationError(...args)
                },
                error: (err) => console.error(err)
            });

            this.validationSuccessSubject = new Subject()
                .groupBy((data) => data.id + data.field)
                .mergeMap(group => group
                        .auditTime(Config.TEXT_INPUT_DEBOUNCE_TIME)
                    // .debounceTime(Config.TEXT_INPUT_DEBOUNCE_TIME)
                );
            this.validationSuccessSubject.subscribe({
                // Pass arguments as they would've been passed without this HOC
                next: (args) => {
                    this.props.onValidationSuccess(...args)
                },
                error: (err) => console.error(err)
            });
        }

        onValueChanged() {
            // Assign to new array, stripping out arguments object properties
            let args = [...arguments];
            if (this.valueChangedSubject) {
                this.valueChangedSubject.next(args);
            }
        }

        onValidationError() {
            // Assign to new array, stripping out arguments object properties
            let args = [...arguments];
            if (this.validationErrorSubject) {
                this.validationErrorSubject.next(args);
            }
        }

        onValidationSuccess() {
            // Assign to new array, stripping out arguments object properties
            let args = [...arguments];
            if (this.validationSuccessSubject) {
                this.validationSuccessSubject.next(args);
            }
        }

        render() {

            return <Component {...this.props}
                              onValidationSuccess={this.onValidationSuccess.bind(this)}
                              onValidationError={this.onValidationError.bind(this)}
                              onPersistValue={this.onValueChanged.bind(this)}
                              onValueChanged={this.onValueChanged.bind(this)} /> // Bind so function is passed directly, in order for it to have arguments object
        }
    }
};

export default debounceValueChanged;


// WEBPACK FOOTER //
// ./public/hoc/DebounceValueChanged.jsx